import { render } from "./ListaSinistrosPagamentoView.vue?vue&type=template&id=62fe6f4a&scoped=true"
import script from "./ListaSinistrosPagamentoView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosPagamentoView.vue?vue&type=script&lang=js"

import "./ListaSinistrosPagamentoView.vue?vue&type=style&index=0&id=62fe6f4a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fe6f4a"]])

export default __exports__